import { render } from "./Onboarding.vue?vue&type=template&id=329cabc4&ts=true"
import script from "./Onboarding.vue?vue&type=script&lang=ts"
export * from "./Onboarding.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__